var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 169,
    viewBox: "0 0 127 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_502_1265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.75 20.25C110.992 15.25 109.693 8.00679 108.167 2.71574C106.892 -1.70452 103.187 -4.84692 98.7591 -6.09426C88.9045 -8.87021 79.125 -1.4649 79.125 8.77325V133.693C79.125 137.963 80.4266 142.131 82.8562 145.642L105.105 177.795C114.526 191.411 135.889 184.339 135.325 167.791C135.124 161.884 131.795 156.531 126.587 153.738L97.9741 138.391C95.1938 136.899 92.7455 134.821 91.1793 132.082C89.1694 128.567 86.8035 123.452 87.375 119.625C88.468 112.305 91.2257 108.405 96 102.75C100.724 97.1549 107.147 97.7264 111 91.5C115.426 84.3486 117.55 77.5629 113.625 70.125C111.595 66.2786 112.125 62.625 108.75 59.25C106.686 57.1861 104.903 45.8662 103.828 37.383C103.074 31.4266 106.294 25.7285 108.75 20.25Z",
    fill: "black",
    fillOpacity: 0.63
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.3523C98.1619 57.3523 102.555 120.453 63.0168 120.453C23.4783 120.453 26.6511 57.3523 26.6511 57.3523C26.6511 57.3523 24.7416 19.8247 64.3549 19.8247C101.227 19.8247 98.1619 57.3523 98.1619 57.3523Z",
    fill: "#F6F6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.3523C98.1619 57.3523 102.555 120.453 63.0168 120.453C23.4783 120.453 26.6511 57.3523 26.6511 57.3523C26.6511 57.3523 24.7416 19.8247 64.3549 19.8247C101.227 19.8247 98.1619 57.3523 98.1619 57.3523Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6863 77.3888V83.4695C60.6863 83.8939 60.7686 84.303 60.9179 84.6771C61.5062 86.1464 63.2008 86.849 64.7323 86.4414L66.5153 85.9699",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3231 69.8525C51.3231 71.6594 49.8556 73.1241 48.0451 73.1241C46.2347 73.1241 44.7656 71.6594 44.7656 69.8525C44.7656 68.0472 46.2347 66.581 48.0451 66.581C49.8556 66.581 51.3231 68.0472 51.3231 69.8525Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8733 69.8525C81.8733 71.6594 80.4057 73.1241 78.5953 73.1241C76.7849 73.1241 75.3158 71.6594 75.3158 69.8525C75.3158 68.0472 76.7849 66.581 78.5953 66.581C80.4057 66.581 81.8733 68.0472 81.8733 69.8525Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5944 93.7137C55.5944 93.7137 58.816 95.7213 63.0647 95.7213C67.3134 95.7213 70.535 93.7137 70.535 93.7137",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9292 57.0908C55.7585 57.4194 54.9493 61.4255 54.9493 61.4255L36.9181 63.3617L41.2171 60.2802C42.3144 59.5761 43.5381 59.0863 44.8182 58.8399L55.9292 57.0908Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7085 57.0908C68.8792 57.4194 69.6884 61.4255 69.6884 61.4255L87.7196 63.3617L83.4206 60.2802C82.3234 59.5761 81.1012 59.0863 79.8195 58.8399L68.7085 57.0908Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.2473C98.0861 92.9203 103.249 90.5173 106.242 85.7354C109.237 80.9551 110.634 71.393 106.242 68.8028C101.852 66.2112 98.1501 71.5512 98.1501 71.5512C98.1501 71.5512 97.0819 81.2183 96.3031 84.8335L95.4116 89.2473Z",
    fill: "#F6F6F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.2473C98.0861 92.9203 103.249 90.5173 106.242 85.7354C109.237 80.9551 110.634 71.393 106.242 68.8028C101.852 66.2112 98.1501 71.5512 98.1501 71.5512C98.1501 71.5512 97.0819 81.2183 96.3031 84.8335L95.4116 89.2473Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9713 80.4439C100.484 73.1708 105.763 74.7784 105.763 74.7784",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7037 76.8466C99.7037 76.8466 105.088 79.7212 101.531 84.0391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.2087C26.652 92.8803 21.8181 90.5167 18.8236 85.7364C15.8306 80.9546 14.4331 71.3924 18.8236 68.8023C23.2156 66.2121 26.9172 71.5521 26.9172 71.5521",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.2087C26.652 92.8803 21.8181 90.5167 18.8236 85.7364C15.8306 80.9546 14.4331 71.3924 18.8236 68.8023C23.2156 66.2121 26.9172 71.5521 26.9172 71.5521",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3048 74.7791C19.3048 74.7791 24.2546 73.132 27.7657 80.4036",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3635 76.8466C25.3635 76.8466 19.9794 79.7212 23.5363 84.0391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1232 16.746C74.4118 13.3969 68.1179 12.1817 62.3681 12.4068C56.6198 12.1817 50.3259 13.3969 43.613 16.746C13.8962 31.5751 26.298 71.2199 26.298 71.2199L26.4443 69.5088C27.3282 68.3438 32.1499 61.673 34.157 52.7298H90.2607C92.2738 63.5772 97.8652 70.0396 98.0648 70.6206C98.1379 69.8617 98.1776 69.0708 98.2035 68.2662L98.8771 71.2199C98.8771 71.2199 110.841 31.5751 81.1232 16.746Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.238 8.37626C104.238 20.2411 94.601 29.861 82.7112 29.861C70.8215 29.861 61.1841 20.2411 61.1841 8.37626C61.1841 -3.49009 70.8215 -13.11 82.7112 -13.11C94.601 -13.11 104.238 -3.49009 104.238 8.37626Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 152.904C107.436 152.904 81.2185 147.138 79.3792 138.584V115.747",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4715 115.69V138.585C46.4715 138.585 39.2587 149.414 19.4811 152.834",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.508 206.556C147.508 177.465 118.809 158.654 110.283 153.706C108.908 152.909 107.215 152.918 105.867 153.761C96.9196 159.355 60.0464 179.101 20.4637 153.2C19.7139 152.708 18.7584 152.66 17.9751 153.096C11.1631 156.892 -20.3199 176.085 -20.3199 206.556",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3541 149.716C31.3541 149.716 58.9892 165.787 95.4585 149.637",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6106 115.911C46.6106 115.911 53.4409 131.171 67.2965 130.199C67.2965 130.199 77.1777 130.106 79.5185 120.294L78.5447 115.911C78.5447 115.911 66.0819 124.77 46.6106 115.911Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_502_1265",
    x: 76.125,
    y: -9.68207,
    width: 62.2112,
    height: 197.663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_502_1265"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.f8239407e35c3675b7a66a538f940b32.svg";
export { ForwardRef as ReactComponent };